var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'base-textinput-container', 
    { disabled: _vm.disabled } ].concat( _vm.styles
  )},[_c('input',_vm._g(_vm._b({attrs:{"type":"text","placeholder":_vm.placeholder,"disabled":_vm.disabled,"maxlength":_vm.maxLength,"autocomplete":_vm.autocomplete},domProps:{"value":_vm.value},on:{"input":_vm.checkValidity}},'input',_vm.$attrs,false),_vm.inputListeners))])}
var staticRenderFns = []

export { render, staticRenderFns }